// Executes inline JS via a <script> element instead of new Function/eval,
// so the app can run without 'unsafe-eval' in its Content-Security-Policy.
export function runInlineScript(code?: string): void {
  if (!code) {
    return;
  }

  const script = document.createElement('script');
  script.textContent = code;
  document.body.appendChild(script);
  document.body.removeChild(script);
}
